<template>
    <el-dialog title="条款文件上传" :visible.sync="dialogVisible">
      <el-upload ref="upload" accept=".PDF" action="" multiple
                :auto-upload="false"
                :headers="headers"
                :http-request="handleUploadFile"
                :before-upload="handleBeforeUpload"
                :on-change="handleChange"
                :show-file-list="false"
                :file-list="file_list">
        <el-button type="primary" size="small">选择文件</el-button>
        <div class="el-upload__tip" slot="tip" style="color: red;">{{ '说明: 只能上传pdf文件' }}</div>
      </el-upload>
      <!-- 业务table -->
      <el-table :key="1" :data="file_list" stripe fit highlight-current-row class="w-100 mt-1" size="mini">
        <!-- 名称 -->
        <el-table-column align="left" label="文件名称" width="220">
          <template slot-scope="scope">
            <span class="text-link">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" width="150" prop="insurancetype">
          <template slot="header">
            <span style="color: red;">*</span><span>适用险种</span>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.relatetype" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div style="color: red; font-size: 8px;">{{scope.row.error_message}}</div>
          </template>
        </el-table-column>
        <el-table-column align="left" label="重命名" min-width="100" prop="rename">
          <template slot-scope="scope">
            {{ rename(scope.row) }}
          </template>
        </el-table-column>

        <!-- 大小 -->
        <el-table-column align="left" label="文件大小" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.size }}</span>
          </template>
        </el-table-column>

        <!-- 按钮组 -->
        <el-table-column align="left" label="操作" class-name="small-padding" width="60">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="handleDelete(scope.row)" icon="el-icon-delete"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="success" size="small" style="float: right" @click="handleUpload">上传<i class="el-icon-upload"></i></el-button>
    </el-dialog>
</template>

<script>
import { getToken } from "@/utils/auth"
import { uploadCompanyFile } from "@/api/insurance_company"

export default {
    name: 'upload-dialog',
    props: {
      companyData: {
        type: Object,
        required:true
      }
    },
    data() {
      return {
        dialogVisible: false,
        relatetype: '',
        options: [
          {label: "船壳险86条款", value: "ArMain86"},
          {label: "船壳险96条款", value: "ArMain96"},
          {label: "船壳附加-螺旋桨", value: "ArPropeller"},
          {label: "船壳附加-四分之一", value: "ArQuarter"},
          {label: "船壳附加-油污", value: "ArOil"},
          {label: "船壳附加-货物承运人", value: "ArCargo"},
          {label: "船壳附加-船东对船员", value: "ArOwner2Seaman"},
          {label: "船壳附加-船东对旅客", value: "ArOwner2Psg"},
          {label: "船壳附加-第三者港澳", value: "Ar3PersonHK"},
          {label: "船壳附加-第三者", value: "Ar3Person"},
          {label: "船壳附加-桥梁", value: "ArBridge"},
          {label: "船壳附加-拖轮", value: "ArTug"},
          {label: "船壳附加-所有", value: "ArTotal"},
          {label: "保赔险", value: "PiMain"},
          {label: "雇主险", value: "EliMain"},
          {label: "其他", value: "Other"},
        ],
        file_list: [],
      }
    },
    computed: {
      headers() {
        return {
          Authorization: "Token " + getToken()
        }
      },
      rename() {
        return function (row) {
          let new_name = ''
          if (typeof(row.relatetype) == 'undefined') {
            new_name = row.name
          }
          else {
            new_name = this.companyData.short_name + '-' + this.companyData.id + '-' + row.relatetype + '.pdf'
          }
          row.new_name = new_name

          return new_name
        }
      },
    },
    methods: {
      openDialog() {
        this.dialogVisible = true
      },
      handleBeforeUpload(file) {
        let upload = true

        this.file_list.forEach(item => {
          if (!(item.raw.type === 'application/pdf')) {
            this.$set(item, 'error_message', '文件不是PDF格式')
            upload = false
            return
          }

          if (item.name.length > 64) {
            this.$set(item, 'error_message', '原文件名称过长')
            upload = false
            return
          }

          if (typeof(item.relatetype) == 'undefined') {
            this.$set(item, 'error_message', '请选择适用险种')
            upload = false
            return
          }

          this.$set(item, 'error_message', undefined)
        })

        return upload
      },
      handleChange(file, fileList) {
        if (fileList.length > 1) {
          this.$refs.upload.fileList.some(item => {
            if (item.status !== 'success' && item.name == file.name && item.size == file.size) {
              this.$message.error("文件[" + file.name + "]已经选择，请勿重复上传")
              fileList.pop()
              return true
            }
          })
        }
        this.file_list = fileList
      },
      handleDelete(file) {
        let index = this.$refs.upload.fileList.indexOf(file)
        if (index != -1) {
          this.$refs.upload.fileList.splice(index, 1)
        }
      },
      handleUpload() {
        this.$refs.upload.submit();
      },
      handleUploadFile(param) {
        let file_obj, finished = false, file = param.file

        file_obj = this.file_list.find(item => {
          return (item.name === file.name && item.size === file.size)
        })

        // 加载表单数据
        let fd = new FormData()

        fd.append("file", file)
        fd.append("new_name", file_obj.new_name)

        uploadCompanyFile(this.companyData.id, fd)
        .then(() =>{
            this.$set(file_obj, 'uploaded', true)
            this.$message.success('保险条款文件上传成功')

            finished = !this.file_list.some(item => {
              return (!item.uploaded)
            })

            if (finished) {
              this.file_list = []
              this.$refs.upload.clearFiles()
              this.dialogVisible = false
              this.$emit('uploaded')
            }
        })
        .catch(error => {
            this.$message.error(error)
        })
      },
    }
}
</script>